import React, { useEffect } from "react";
import {
  P,
  SectionHeading,
  SectionSubHeading,
  SectionWrapper,
} from "../../../styles";
import Menu from "./menu";
import Aos from "aos";
import "aos/dist/aos.css";

import styles from "../S1_Header/scroll.module.css";
import S2_DollerInu from "../S2_DollerInu";
import S3_Sacrifice from "../S3_Sacrifice";
import S4_Roadmap from "../S4_Roadmap";
import S5_Collabs from "../S5_Collabs";
import S6_Faq from "../S6_faq";
import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material"; 

const Heading = styled.div`
  color: #ffffff;
  display: inline-block;
  font: 180px "twocent-bold-italic";
  letter-spacing: 65px;
  margin-top: ${(props) => (props.m ? props.m : "80px")};
  @media screen and (max-width: 1510px) {
    font-size: 160px;
  }
  @media screen and (max-width: 1430px) {
    font-size: 130px;
  }
  @media screen and (max-width: 1302px) {
    letter-spacing: 55px;
    font-size: 130px;
  }
  @media screen and (max-width: 1200px) {
    letter-spacing: 50px;
    font-size: 120px;
    margin-bottom: 20px;
  }
  @media screen and (max-width: 1100px) {
    letter-spacing: 45px;
  }
  @media screen and (max-width: 1050px) {
    letter-spacing: 35px;
  }
  @media screen and (max-width: 930px) {
    font-size: 80px;
    letter-spacing: 25px;
  }
  @media screen and (max-width: 654px) {
    font-size: 70px;
    letter-spacing: 15px;
  }
  @media screen and (max-width: 654px) {
    font-size: 53px;
    letter-spacing: 15px;
  }
`;
const Richie = styled.div`
  position: absolute;
  left: 0;
  top: 50px;
  right: 0;
  text-align-last: center;
  @media screen and (max-width: 1350px) {
    top: 20px;
  }
  @media screen and (max-width: 899px) {
    top: 6px;
    left: unset;
    width: 183px;
  }
`;
const Socials = styled.div`
  margin-left: 170px;
  display: flex;
  align-items: center;
  @media screen and (max-width: 899px) {
    margin-left: 0px;
  }
`;
const SocialLinks = styled.a`
  cursor: pointer;
  margin-left: 10px;
`;
const BigScreen = styled.div`
  display: flex;
  @media screen and (max-width: 900px) {
    display: none;
  }
`;
const DisplayFlex = styled.div`
  display: none;
  @media screen and (max-width: 900px) {
    display: flex;
  }
`;
const SocialImage = styled.img`
  width: 100%;
  height: auto;
  max-width: 35px;
`;
const RichieImage = styled.img`
  width: 100%;
  height: auto;
  max-width: 326px;
`;
const Index = () => {
  
  useEffect(() => {
    Aos.init({ duration: 2000 });
    window.addEventListener("load", function () {
      Aos.init();
    });
  }, []);
  return (
    <div style={{ backgroundColor: "#4F8443" }}>
      <Menu />
      <figure className={styles.figure}>
        <SectionWrapper
          id="explore"
          // data-aos="fade-zoom-in"
          // data-aos-easing="ease-in"
          // data-aos-delay="500"
          // data-aos-offset="0"
        >
          <Container maxWidth="xl">
            <Heading>Richie Rich</Heading>
            <Grid container>
              <Grid xs={12} md={6}>
                <SectionSubHeading maxWidth599="200px">
                  Efficient, Cheaper, Faster Ethereum Fork
                </SectionSubHeading>
              </Grid>
              <Grid xs={12} md={6}>
                <P ml599="0px" ml="170px" maxWidth="65%">
                  In remembrance of one of the greatest animated characters of
                  all time…
                  <br />
                  Introducing, the ‘Richie Rich Chain’! The RRC is destined to
                  become the first blockchain that embraces the world of meme
                  lords (or what we like to call it, the ‘Memeverse’!) by
                  creating meme tokens with powerful use cases.
                  <br />
                  <br />
                  Want to be as rich as Richie Rich? Then be an active part of
                  our Telegram community to know how!
                </P>
                <Socials>
                  <P>Stay Connected:</P>
                  <SocialLinks href="#">
                    <SocialImage
                      src="/images/twitter.png" 
                    />
                  </SocialLinks>
                  <SocialLinks href="#">
                    <SocialImage
                      src="/images/telegram.png" 
                    />
                  </SocialLinks>
                </Socials>
              </Grid>
            </Grid>
            <Richie>
              <RichieImage
                src="/images/richierich.png" 
              />
            </Richie>
          </Container>
        </SectionWrapper>
      </figure>
      {/* small screnn */}
      <DisplayFlex>
        <SectionWrapper
          id="explore"
          // data-aos="fade-zoom-in"
          // data-aos-easing="ease-in"
          // data-aos-delay="500"
          // data-aos-offset="0"
        >
          <Container maxWidth="xl">
            <Heading>Richie Rich</Heading>
            <Grid container>
              <Grid xs={12} md={6}>
                <SectionSubHeading maxWidth599="200px">
                  Efficient, Cheaper, Faster Ethereum Fork
                </SectionSubHeading>
              </Grid>
              <Grid xs={12} md={6}>
                <P ml599="0px" ml="170px" maxWidth="65%">
                  In remembrance of one of the greatest animated characters of
                  all time…
                  <br />
                  Introducing, the ‘Richie Rich Chain’! The RRC is destined to
                  become the first blockchain that embraces the world of meme
                  lords (or what we like to call it, the ‘Memeverse’!) by
                  creating meme tokens with powerful use cases.
                  <br />
                  <br />
                  Want to be as rich as Richie Rich? Then be an active part of
                  our Telegram community to know how!
                </P>
                <Socials>
                  <P>Stay Connected:</P>
                  <SocialLinks href="#">
                    <SocialImage
                      src="/images/twitter.png" 
                    />
                  </SocialLinks>
                  <SocialLinks href="#">
                    <SocialImage
                      src="/images/telegram.png" 
                    />
                  </SocialLinks>
                </Socials>
              </Grid>
            </Grid>
            <Richie>
              <RichieImage
                src="/images/richierich.png" 
              />
            </Richie>
          </Container>
        </SectionWrapper>
      </DisplayFlex>
      <figure className={styles.figure}>
        <S2_DollerInu />
      </figure>
      <figure className={styles.figure}>
        <S3_Sacrifice />
      </figure>
      <figure className={styles.figure}>
        <S4_Roadmap />
      </figure>
      <figure className={styles.figure}>
        <S5_Collabs />
      </figure>
      <figure className={styles.figure}>
        <S6_Faq />
      </figure>
      <DisplayFlex>
        <S2_DollerInu />
      </DisplayFlex>
      <DisplayFlex>
        <S3_Sacrifice />
      </DisplayFlex>
      <DisplayFlex>
        <S4_Roadmap />
      </DisplayFlex>
      <DisplayFlex>
        <S5_Collabs />
      </DisplayFlex>
      <DisplayFlex>
        <S6_Faq />
      </DisplayFlex>
    </div>
  );
};

export default Index;
